window.category = window.category || {};

function parsePrice(priceString)
{
    const cleanedPriceString = priceString.replace(/[^\d.,]/g, '');
    const match = cleanedPriceString.match(/([\d]+)[,\.]?([\d]*)/);

    if (!match)
        return 0; // Return null if no valid number is found

    let integerPart = match[1];
    let decimalPart = match[2] ? "." + match[2] : "";

    return parseFloat(integerPart + decimalPart);
}

window.category.createActionFlagAsync = async function (data, extraClass)
{
    var actionString = await localization.get("product.akce");

    var span = document.createElement("span");
    span.className = `badge text-bg-danger ${extraClass}`;
    span.innerHTML = `${actionString}`;

    return span;
};

window.category.createDiscountFlagAsync = async function (data, extraClass)
{
    var oldPrice = parsePrice(data.oldPrice);
    var price = parsePrice(data.price);

    if (oldPrice == 0)
        return "";

    var discount = Math.round((oldPrice - price) / oldPrice * 100, 0);

    var discountString = await localization.get("product.sleva");

    var span = document.createElement("span");
    span.className = `badge text-bg-danger ${extraClass}`;
    span.innerHTML = `${discountString} ${discount}%`;

    return span;
};

window.category.loadMoreAsync = async function (button, endpoint)
{
    button.disabled = true;
    button.classList.add("disabled");

    var page = parseInt(button.dataset.page) + 1;

    button.dataset.page = page;

    var parameters = new URLSearchParams(window.location.search);
    parameters.set("page", page);

    var url = `${document.baseURI}${endpoint}?${parameters.toString()}`;
    var method = "GET";
    var headers =
    {
        'X-Requested-With': 'XMLHttpRequest'
    };

    progress.show();

    var data = null;

    try
    {
        const response = await fetch(url,
        {
            method: method,
            headers: headers,
        });

        if (!response.ok)
            throw new Error('Network response was not ok.');

        data = await response.text();
    }
    catch (error)
    {
        progress.hide();

        button.disabled = false;
        button.classList.remove("disabled");

        console.error('Error:', error);

        return;
    }

    button.disabled = false;
    button.classList.remove("disabled");

    var containers = document.querySelectorAll("div[data-category-body] div[data-products]");
    var container = containers[containers.length - 1];

    if (container)
    {
        var tempContainer = document.createElement("div");
        tempContainer.innerHTML = data;

        var tempProductsContainer = tempContainer.querySelector("div[data-products]");

        container.innerHTML += tempProductsContainer.innerHTML;

        var paginationContainer = tempContainer.querySelector("div[data-category-pagination]");

        if (paginationContainer.dataset.nextPage === "False")
            button.remove();

        var pagination = document.querySelector("ul.pagination");

        if (pagination)
            pagination.parentNode.outerHTML = paginationContainer.innerHTML;

        tempContainer.remove();

        price.asyncPrice();
        images.load();
    }
    else
        console.log("Products container not found.");

    progress.hide();

    var newUrl = new URL(location.href)
    newUrl.searchParams.set("page", page);

    var modifiedUrl = newUrl.toString();

    window.history.pushState({}, document.title, modifiedUrl);
};

window.category.init = function ()
{
    var loadMoreCategoryButton = document.querySelector("button[data-category-load-more]");
    var loadMoreSearchButton = document.querySelector("button[data-search-load-more]");

    if (loadMoreCategoryButton)
    {
        loadMoreCategoryButton.addEventListener("click", async () =>
        {
            await category.loadMoreAsync(loadMoreCategoryButton, `category/loadMore/${loadMoreCategoryButton.dataset.categoryLoadMore}`);
        });
    }

    if (loadMoreSearchButton)
    {
        loadMoreSearchButton.addEventListener("click", async () =>
        {
            await category.loadMoreAsync(loadMoreSearchButton, `search/loadMore/${loadMoreSearchButton.dataset.searchLoadMore}`);
        });
    }
};